import RastreabilidadeFabricaService from '@/services/RastreabilidadeFabricaService';
import RastreabilidadePortService from '@/services/RastreabilidadePortService';
import RastreabilidadeEmprestimoService from '@/services/RastreabilidadeEmprestimoService';

export const fetchFactories = async ({ state, commit }) => {
    try {
        const page = state.factoryFilter.page ? state.factoryFilter.page - 1 : 0;
        const size = state.factoryFilter.size ?? 10;
        const body = {
            searchText: state.searchText
        };
        const response = await RastreabilidadeFabricaService.getFactoriesPaginatedByFilter(body, page, size);
        commit('SET_FACTORY_LIST', response.data);
    } catch (error) {
        throw error;
    }
};

export const fetchTotalizers = async ({ commit }) => {
    try {
        const response = await RastreabilidadeFabricaService.getTotalizers();
        commit('SET_FACTORY_TOTALIZER', response.data);
    } catch (error) {
        throw error;
    }
};

export const fetchPorts = async ({ state, commit }) => {
    try {
        const page = state.portFilter.page ? state.portFilter.page - 1 : 0;
        const size = state.portFilter.size ?? 10;
        const body = {
            searchText: state.searchText
        };
        const response = await RastreabilidadePortService.getPortsPaginatedByFilter(body, page, size);
        commit('SET_PORT_LIST', response.data);
    } catch (error) {
        throw error;
    }
};

export const fetchPortTotalizers = async ({ state, commit }) => {
    try {
        const response = await RastreabilidadePortService.getTotalizers(state.portFilter.portId);
        commit('SET_PORT_TOTALIZER', response.data);
    } catch (error) {
        throw error;
    }
};

export const fetchLoanTotalizer = async ({ state, commit }, idArmazem, idProduto, idEmpresaEmprestimo) => {
    try {
        const response = await RastreabilidadeEmprestimoService.getLoanTotalizer(idArmazem, idProduto, idEmpresaEmprestimo);
        commit('SET_LOAN_TOTALIZER', response.data);
    } catch (error) {
        throw error;
    }
};

export const fetchLoanTotalizerModal = async ({ state, commit }, params) => {
    try {
        const response = await RastreabilidadeEmprestimoService.getLoanTotalizer(params.idArmazem, params.idProduto, params.idEmpresaEmprestimo);
        commit('SET_LOAN_TOTALIZER_MODAL', response.data);
    } catch (error) {
        throw error;
    }
};

export const fetchLoanCompaniesByFacility = async ({state, commit}, idArmazem) => {
    try {
        const response = await RastreabilidadeEmprestimoService.buscarEmpresasEmprestimoByArmazem(idArmazem);
        commit('SET_LOAN_COMPANY_LIST', response.data.empresas);
    } catch (error) {
        throw error;
    }
};

export const fetchLoans = async ({ state, commit }, params) => {
    try {
        const page = params.page ? params.page - 1 : 0;
        const size = params.size ?? 10;
        const ordenacao = params.ordenacao ?? 'dataCadastro,desc';
        const body = {
            idArmazem: params.idArmazem,
            idProduto: params.idProduto,
            idEmpresaEmprestimo: params.idEmpresaEmprestimo
        };
        const response = await RastreabilidadeEmprestimoService.getLoansPaginatedByFilter(body, page, size, ordenacao);
        commit('SET_LOANS_LIST', response.data);
    } catch (error) {
        throw error;
    }
};
